import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from "react-toastify";
import axios from "axios";
import Cookies from 'js-cookie';

// AsyncThunk to handle login
export const loginUser = createAsyncThunk(
    'auth/loginUser',
    async (_, { rejectWithValue }) => {
      try {
        const token = Cookies.get('authToken'); // Get the token from cookies
        if (!token) throw new Error('No token found');
        const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
       

        const response = await axios.post(
          REACT_APP_API_BASE_URL + "/public/users/user_info",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        
        // Handle the new response structure with Response wrapper
        const userData = response.data.Response || response.data;
        
        // Return the user data with the new structure
        return {
          accountId: userData.accountId,
          accountType: userData.accountType,
          username: userData.username,
          email: userData.email,
          phoneNumber: userData.phoneNumber,
          onboarding_complete: userData.onboarding_complete
        };
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Login failed');
      }
    }
  );

// // Async thunk to handle password reset
// export const resetPassword = createAsyncThunk(
//     "auth/resetPassword", 
//     async ({ password, confirmPassword, token }, { rejectWithValue }) => {
//         try {
//             const response = await axios.post(
//                 "https://an2sldwgo0.execute-api.ap-south-1.amazonaws.com/stage1/public/user/reset-password",
//                 { password, confirmPassword, token },
//                 { headers: { "Content-Type": "application/json" } }
//             );
//             return response.data;
//         } catch (error) {
//             return rejectWithValue(error.response?.data || "Failed to reset password");
//         }
//     }
// );

// // Async Thunk code to handle forgotPassword
// export const forgotPassword = createAsyncThunk(
//     "auth/forgotPassword",
//     async (email, { rejectWithValue }) => {
//         try {
//             const response = await axios.post(
//                 'https://an2sldwgo0.execute-api.ap-south-1.amazonaws.com/stage1/public/user/forgot-password',
//                 { email },
//                 {
//                     headers: {
//                         'Content-Type': 'application/json',
//                     }
//                 }
//             );
//             return response.data; 
//         } catch (error) {
//             return rejectWithValue(error?.response?.data || 'Failed to send the request.');
//         }
//     }
// );